import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AddClient from "./pages/AddClient";
import Clients from "./pages/Clients";
import Leads from "./pages/Leads";
import BotTester from "./pages/BotTester";
import EditClient from "./pages/EditClient";
import Users from "./pages/Users";
import Landing from "./pages/Landing";
import Analytics from "./pages/Analytics";
import Handoffs from "./pages/Handoffs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import RefundPolicy from "./pages/RefundPolicy";
import Contact from "./pages/Contact";
import OnboardSuccess from "./pages/OnboardSuccess";
import OnboardError from "./pages/OnboardError";
import ClientSettings from "./pages/ClientSettings";
import Signup from "./pages/Signup";
import WidgetDocs from "./pages/WidgetDocs";


export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/onboard-success" element={<OnboardSuccess />} />
          <Route path="/onboard-error" element={<OnboardError />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/widget" element={<WidgetDocs />} />



          {/* Protected routes */}
          <Route path="/app" element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }>
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="handoffs" element={<PrivateRoute adminOnly={true}><Handoffs /></PrivateRoute>} />
            <Route path="leads" element={<Leads />} />
            <Route path="clients" element={<PrivateRoute adminOnly={true}><Clients /></PrivateRoute>} />
            <Route path="users" element={<PrivateRoute adminOnly={true}><Users /></PrivateRoute>} />
            <Route path="add-client" element={<PrivateRoute adminOnly={true}><AddClient /></PrivateRoute>} />
            <Route path="edit-client/:id" element={<EditClient />} />
            <Route path="settings" element={<ClientSettings />} />

            <Route path="bot-tester" element={<PrivateRoute adminOnly={true}><BotTester /></PrivateRoute>} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}